export default "__VITE_ASSET__DukH6qcF__"